import { render, staticRenderFns } from "./ConfirmarGeracao.vue?vue&type=template&id=226e0649&scoped=true&"
import script from "./ConfirmarGeracao.vue?vue&type=script&lang=js&"
export * from "./ConfirmarGeracao.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmarGeracao.vue?vue&type=style&index=0&id=226e0649&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226e0649",
  null
  
)

export default component.exports